import {
  API_SET_CONTEXT_FILTER,
  API_SET_CONTEXT_LIST,
  API_REFRESH,
} from "../constants/actionTypes";

export function apiSetContextFilter(filter) {
  return {
    type: API_SET_CONTEXT_FILTER,
    filter,
  };
}

export function apiSetContextList(list) {
  return {
    type: API_SET_CONTEXT_LIST,
    list,
  };
}

export function apiRefresh(status) {
  return {
    type: API_REFRESH,
    status,
  };
}
